import React from 'react';
import { downloadInvoice, UserInvoicesDto } from 'Services/Api/_HumanWritten/InvoiceService';
import { formatStandardDate } from 'Util/_HumanWritten/DateUtils';
import { Button } from '../../Button/Button';
import { formatCurrency } from 'Util/_HumanWritten/CurrencyUtils';

export interface InvoiceRenderProps {
	invoice: UserInvoicesDto;
}

function getAmountString(price: number): string {
	return `${formatCurrency(price)}`;
}

export function InvoiceRender({ invoice }: InvoiceRenderProps) {
	return (
		<tr>
			<td className="invoice-created-date__column">{formatStandardDate(invoice.createdDate)}</td>
			<td className="invoice-id__column">#{invoice.humanReadableId}</td>
			<td className="invoice-type__column">{invoice.purchaseType}</td>
			<td className="invoice-total__column">{getAmountString(invoice.invoiceAmount)}</td>
			<td className="download-button__column">
				<Button
					onClick={() =>
						downloadInvoice(
							invoice.invoiceId,
							invoice.isEventBooking,
							invoice.isVoucherPurchase,
							invoice.isParkingPurchase,
							invoice.isAnytimeTicket,
						)
					}
					className="link-download-invoice link-rm-txt-dec hide-underline"
				>
					Download{invoice.isInvoiced && <> (Invoiced)</>}
				</Button>
			</td>
		</tr>
	);
}
